export const toNumber = (value: unknown, fallback = 1) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) ? parsed : fallback;
};
